import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Input from "./common/Input";
import Select from "./common/Select";
import { getContact, getCareTeam } from "./services/soar";
import { getFieldName, getFieldDate } from "../scripts/helperScripts";

function ExternalSignaturesModal({
  contactId,
  isOpen,
  closeModal,
  handleSetRecipients,
}) {
  const [data, setData] = useState([
    {
      ahEmail: "",
      ahName: "",
      email: "",
      name: "",
    },
  ]);
  const [external, setExternal] = useState([]);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const formatName = (name) => {
    let ctName = name.split(", ");
    ctName = ctName[1] ? `${ctName[1]} ${ctName[0]}` : ctName[0];
    return ctName;
  };

  useEffect(() => {
    getCareTeam(contactId).then((response) => {
      let externalOptions = response
        .filter(
          (ct) =>
            ct.ccx_memberid === undefined &&
            ct["con.emailaddress1"] !== undefined
        )
        .map((member) => {
          return {
            _id: member["con.emailaddress1"],
            name: `${formatName(
              getFieldName(member.ccx_contact)
            )} (${getFieldName(member.sor_contactrole)}) ${
              member.ccx_expdate
                ? `Expired as of ${getFieldDate(member.ccx_expdate)}`
                : ""
            }`,
            fullName: formatName(getFieldName(member.ccx_contact)),
            role: getFieldName(member.sor_contactrole),
          };
        });

      getContact(contactId).then((response) => {
        if (response[0] && response[0].emailaddress1) {
          externalOptions.splice(0, 0, {
            _id: response[0].emailaddress1,
            name: `${response[0].fullname} (client)`,
            fullName: response[0].fullname,
            role: "client",
          });
        }

        setExternal(externalOptions);
      });
    });
  }, [isOpen === true]);

  const handleSelect = ({ currentTarget: input }, index) => {
    const obj = [...data];
    const member = external[input.selectedIndex - 1];
    obj[index][`ahEmail`] = member._id;
    obj[index][`ahName`] = member.fullName;
    obj[index]["ahRole"] = member.role;
    setData(obj);
  };

  const handleChange = ({ currentTarget: input }, index) => {
    const obj = [...data];
    obj[index][input.name] = input.value;
    setData(obj);
  };

  const setRecipient = (index) => {
    const obj = [...data];
    obj[index]["email"] = obj[index][`ahEmail`];
    obj[index]["name"] = `${obj[index]["ahName"]} (${obj[index]["ahRole"]})`;
    setData(obj);
  };

  const deleteRecipient = (index) => {
    const obj = [...data];
    obj[index]["email"] = "";
    obj[index]["name"] = "";
    obj[index]["ahEmail"] = "";
    obj[index]["ahName"] = "";
    obj[index]["ahRole"] = "";
    setData(obj);
  };

  const removeRecipient = (index) => {
    const obj = [...data];
    obj.splice(index, 1);
    setData(obj);
  };

  const addAnotherRecipient = () => {
    let obj = [...data];
    const signers = obj.length;
    if (signers < 7) {
      const newSigner = {
        ahEmail: "",
        ahName: "",
        ahRole: "",
        email: "",
        name: "",
      };
      obj.push(newSigner);
      setData(obj);
    }
  };

  const sendToExternal = () => {
    if (process.env.REACT_APP_ENVIRONMENT !== "Production") {
      alert(
        "Test Org: All recpient emails will be sent to you the logged in user"
      );
    }
    const recipients = data.filter(
      (r) => r.email !== "" && r.email !== undefined
    );
    const recipientJSON = recipients.map((r, index) => ({
      email:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? r.email
          : safyInfo.user.email,
      name: r.name,
      roleName: `Signature ${index + 1}`,
      recipientId: `${index + 1}`,
    }));
    console.log("Recipient JSON", recipientJSON);
    handleSetRecipients(recipientJSON);
    setData([
      {
        ahEmail: "",
        ahName: "",
        email: "",
        name: "",
      },
    ]);
    closeModal();
  };

  return isOpen ? (
    <Modal className="rounded" show={isOpen} animation={false}>
      <Modal.Header className="bg-safy3-1">
        <Modal.Title>Get External Signatures</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="h5">Signers</div>
        <small className="text-danger">
          Only clients and collaterals with an email will show up in selection
        </small>
        {data.map((signer, index) => (
          <div className="mt-4" key={`ExtSig${index}`}>
            <div className="h6">{`Signature ${index + 1}`}</div>
            {data[index]["email"] === "" ? (
              <>
                <Select
                  name={`select`}
                  label="Select from Collateral Care Team"
                  options={external}
                  onChange={(e) => handleSelect(e, index)}
                />
                or Ad Hoc
                <Input
                  name={`ahName`}
                  label="Name"
                  value={data[index][`ahName`]}
                  onChange={(e) => handleChange(e, index)}
                />
                <Input
                  name={`ahEmail`}
                  label="Email"
                  value={data[index][`ahEmail`]}
                  onChange={(e) => handleChange(e, index)}
                />
                <Input
                  name={`ahRole`}
                  label="Role"
                  value={data[index][`ahRole`]}
                  onChange={(e) => handleChange(e, index)}
                />
                <button
                  className="btn btn-success me-2"
                  onClick={() => setRecipient(index)}
                  disabled={
                    data[index].ahEmail === "" ||
                    data[index].ahName === "" ||
                    data[index].ahRole === ""
                  }
                >
                  Set Recipient
                </button>
                {index > 0 && (
                  <button
                    className="btn btn-danger"
                    onClick={(e) => removeRecipient(index)}
                  >
                    Remove Recipient
                  </button>
                )}
              </>
            ) : (
              <div className="row border bg-light m-2 p-2">
                <div className="col-10">
                  <div>{data[index]["name"]}</div>
                  <div>{data[index]["email"]}</div>
                </div>
                <div className="col-2">
                  <div
                    className="btn btn-sm btn-danger float-end pt-2"
                    onClick={() => deleteRecipient(index)}
                  >
                    X
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        <div className="row mt-4">
          <div className="col-6">
            {data.length < 7 && (
              <button
                className="btn btn-primary"
                onClick={() => addAnotherRecipient()}
              >
                Add Another Recpient
              </button>
            )}
          </div>
          <div className="col-6 ">
            <button
              className="btn btn-success float-end mx-2"
              onClick={sendToExternal}
              disabled={
                !(data.filter((recipient) => recipient.email !== "").length > 0)
              }
            >
              Send
            </button>
            <div
              className="btn btn-danger float-end"
              onClick={() => closeModal()}
            >
              Cancel
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  ) : null;
}

export default ExternalSignaturesModal;
